import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { Observable } from 'rxjs';
import { Role, MODULE, ROLE_PRIVILEGE, ROUTE, Role_Data } from 'src/app/models/um/organization';

@Injectable({
  providedIn: 'root'
})
export class UmSummaryService {

  constructor(private http: HttpClient) {

  }


  // Department

  addDeptSummary(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/um/departments', obj, httpOptions)
  }

  editDeptSummary(_id, obj): Observable<any> {
    return this.http.put(serviceConstants.apiURL + 'api/um/departments/' + _id, obj, httpOptions)
  }

  getDeptSummary(name?, id?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/department/getdepartments/' + name + '/' + id, httpOptions);
  }

  getDeptSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/department/getadvsearch', searchObject, httpOptions);
  }

  deleteDeptSummary(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/department/delete/' + id, httpOptions);
  }


  // Organization

  addOrgSummary(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/organization/organizations', obj, httpOptions)
  }

  editOrgSummary(_id, obj): Observable<any> {
    return this.http.put(serviceConstants.apiURL + 'api/organization/organizations/' + _id, obj, httpOptions)
  }

  getOrgSummary(_id?): Observable<any> {
    if (_id)
      return this.http.get(serviceConstants.apiURL + 'api/organization/getorganizatoins/' + _id, httpOptions);
    else
      return this.http.get(serviceConstants.apiURL + 'api/organization/getorganizatoins', httpOptions);
  }

  getOrgSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/organization/getadvsearch', searchObject, httpOptions);
  }

  getOrganizations(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getorganizatoins', httpOptions);
  }
  GetOrgsForStorage(orgCode:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/GetOrgsForStorage/'+orgCode, httpOptions);
  }


  deleteOrgSummary(_id): Observable<any> {
    return this.http.delete(serviceConstants.apiURL + 'api/organization/organizations/' + _id, httpOptions);
  }




  // Users

  addUserSummary(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/insert', obj, httpOptions)
  }


  addSupportUser(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/insertsupportuser', obj, httpOptions)
  }

  addUserRole(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/adduserroles', obj, httpOptions)
  }

  editUserSummary(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/update', obj, httpOptions)
  }

  getUserSummary(filter): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getusers/' + filter, httpOptions);
  }
  getUserSearchMaster(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getusersearchmaster', httpOptions);
  }
  getInternalUsers(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getinternalusers', httpOptions);
  }

  getUser(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getuserbyid/' + id, httpOptions);
  }

  checkInternalUser(OrgId: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/checkinternalusers/' + OrgId, httpOptions);
  }

  getSupportUser(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getsupportuserbyid/' + id, httpOptions);
  }

  getUserSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/getadvsearch', searchObject, httpOptions);
  }

  getUserLogSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/common/getadvuserlog', searchObject, httpOptions);
  }

  getUsersById(type: string, orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getusersbyid/' + type + '/' + orgid, httpOptions);
  }
  resendUserEmail(UserID: string, OrgId: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/resenduseremail/' + UserID + '/' + OrgId, httpOptions);
  }
  getUserRoles(id): Observable<string[]> {
    return this.http.get<string[]>(serviceConstants.apiURL + 'api/appuser/getuserroles/' + id, httpOptions);
  }

  getRoleUsers(id): Observable<string[]> {
    return this.http.get<string[]>(serviceConstants.apiURL + 'api/appuser/getroleusers/' + id, httpOptions);
  }


  deleteUserSummary(_id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/delete/' + _id, httpOptions);
  }

  // Roles
  addRole(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/role/insert', obj, httpOptions)
  }

  updateRole(obj): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/role/update', obj, httpOptions)
  }

  editRole(id): Observable<Role_Data> {
    return this.http.get<Role_Data>(serviceConstants.apiURL + 'api/role/getrolebyid/' + id, httpOptions)
  }

  getRole(name?): Observable<Role[]> {
    return this.http.get<Role[]>(serviceConstants.apiURL + 'api/role/getroles/' + name, httpOptions);
  }
  getActiveRole(): Observable<Role[]> {
    return this.http.get<Role[]>(serviceConstants.apiURL + 'api/appuser/getactiveroles', httpOptions);
  }
  getRoleSearchSummary(searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/role/getadvsearch', searchObject, httpOptions);
  }


  deleteRole(_id): Observable<any> {
    return this.http.delete(serviceConstants.apiURL + 'api/role/delete/' + _id, httpOptions);
  }

  getModules(): Observable<MODULE[]> {
    return this.http.get<MODULE[]>(serviceConstants.apiURL + 'api/role/getmodules', httpOptions);
  }

  getRolePrivileges(id: string): Observable<ROLE_PRIVILEGE[]> {
    return this.http.get<ROLE_PRIVILEGE[]>(serviceConstants.apiURL + 'api/role/getroleprivileges/' + id, httpOptions);
  }

  addRolePrivilege(obj: ROLE_PRIVILEGE[]): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/role/insertroleprivilege', obj, httpOptions)
  }

  deleteRoleSummary(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/role/delete/' + id, httpOptions);
  }

  // Privileges

  getPrivilegeSummary(filter): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/privilege/getprivileges/' + filter, httpOptions);
  }

  // Policy Config
  getPolicyConfig(module): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/policy/getpolicymodule/' + module, httpOptions);
  }

  getDocTemp(module): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getpolicymodule/' + module, httpOptions);
  }

  // Policy Config
  getModuleByOrgId(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getmodulesbyid', httpOptions);
  }

  // submitting workflow
  saveSubmit(route: ROUTE): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/common/insertsubmit', route, httpOptions)
  }

  getInstruction(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/instruction/getinstruction/" + id, httpOptions);
  }

  getrouteprogram(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/common/getrouteprogram/" + id, httpOptions);
  }
  getPolicyVersionhistory(moduleCode): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/PolicyVersionDetails/" + moduleCode, httpOptions);
  }
  takeAsLatestPolicy(versionId, policyCode): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/policy/updatepolicywithcurrentversion/" + versionId + "/" + policyCode, null, httpOptions);
  }
  getVersionDetails(versionId, policyCode): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/policy/getVersionDetails/" + versionId + "/" + policyCode, httpOptions);
  }
  getActiveDashboards(): Observable<any[]> {
    return this.http.get<any[]>(serviceConstants.apiURL + 'api/common/getlogidashboards', httpOptions);
  }
  getOrganisationDetailsByID(ID: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/appuser/GetOrgDetails/' + ID, httpOptions)
  }
  refreshUser(userobject: UserInfo): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/Analytics/RefreshUserforLogi', userobject, httpOptions)
  }
}

export class UserInfo{
  ID:string;
  Username:string;
  Email:string;
  OrgId:string;
}